import { TemplateMention, TemplateType } from './index.js';
import { getCaseVoucherTables } from '../economy/case-vouchers/tables.js';
import { PropertyDataType } from '../properties/index.js';
const BasicTemplateMentionSuggestions = [
    TemplateMention.FINANCIALS_PRICIPAL,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES,
    TemplateMention.FINANCIALS_ADMINISTRATION_COSTS,
    TemplateMention.FINANCIALS_COMPENSATION_FEES,
    TemplateMention.FINANCIALS_INTERESTS,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS,
    TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE,
    TemplateMention.PAYMENT_PLAN_FIRST_DATE,
    TemplateMention.PAYMENT_PLAN_LAST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DEADLINE,
    TemplateMention.PAYMENT_PLAN_YEARLY_COSTS,
    TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST,
    TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DATE,
    TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE,
    TemplateMention.PAYMENT_PLAN_ENTRY_DATE,
    TemplateMention.PAYMENT_PLAN_CREATION_DATE,
    TemplateMention.TOTAL_DEBT,
    TemplateMention.OVERPAYMENT,
    TemplateMention.CURRENCY,
    TemplateMention.PRINCIPAL_REFERENECE_IDS,
    TemplateMention.ACCORD_TEN_PERCENT,
    TemplateMention.ACCORD_TWENTY_PERCENT,
    TemplateMention.ACCORD_THIRTY_PERCENT,
    TemplateMention.ACCORD_FORTY_PERCENT,
    TemplateMention.ACCORD_FIFTY_PERCENT,
    TemplateMention.ACCORD_SIXTY_PERCENT,
    TemplateMention.ACCORD_SEVENTY_PERCENT,
    TemplateMention.ACCORD_EIGHTY_PERCENT,
    TemplateMention.ACCORD_NINETY_PERCENT,
    TemplateMention.IF_IS_COMPANY,
    TemplateMention.IF_CASE_HAS_REMINDER_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_COSTS,
    TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS,
    TemplateMention.IF_CASE_HAS_PROCESSRENTE,
    TemplateMention.IF_CASE_HAS_FIXED_INTEREST,
    TemplateMention.IF_CASE_HAS_YEARLT_INTEREST,
    TemplateMention.IF_CASE_HAS_DEPOSIT,
    TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS,
    TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS,
    TemplateMention.DATE,
    TemplateMention.DATE_IN_THREE_DAYS,
    TemplateMention.DATE_IN_SIX_DAYS,
    TemplateMention.DATE_IN_TEN_DAYS,
    TemplateMention.DATE_IN_ELEVEN_DAYS,
    TemplateMention.DATE_IN_TWELVE_DAYS,
    TemplateMention.DATE_IN_FOURTEEN_DAYS,
    TemplateMention.DATE_IN_SEVENTEEN_DAYS,
    TemplateMention.DATE_IN_THIRTY_DAYS,
    TemplateMention.DEPOSIT,
    TemplateMention.DEPOSITS_TO_COLLECTOR,
    TemplateMention.DEPOSITS_TO_CREDITOR,
    TemplateMention.PRINCIPALS_WITH_INTEREST,
    TemplateMention.CONTACT_NAME,
    TemplateMention.DEBTOR_NAME,
    TemplateMention.DEBTOR_FIRST_NAME,
    TemplateMention.CONTACT_ADDRESS,
    TemplateMention.CONTACT_COADDRESS,
    TemplateMention.CONTACT_ZIPCODE,
    TemplateMention.CONTACT_CITY,
    TemplateMention.CONTACT_COUNTRY,
    TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.DEBTOR_ADDRESS,
    TemplateMention.DEBTOR_COADDRESS,
    TemplateMention.DEBTOR_ZIPCODE,
    TemplateMention.DEBTOR_CITY,
    TemplateMention.DEBTOR_COUNTRY,
    TemplateMention.DEBTOR_EMAIL,
    TemplateMention.DEBTOR_PHONE,
    TemplateMention.LAST_PAYMENT_DATE,
    TemplateMention.LAST_PAYMENT_AMOUNT,
    TemplateMention.DEBTOR_SEQ_ID,
    TemplateMention.DEBTOR_CVR_AND_OR_CPR,
    TemplateMention.CREDITOR_NAME,
    TemplateMention.CASE_ID,
    TemplateMention.CASE_REFERENCE_ID,
    TemplateMention.CREDITOR_ADDRESS,
    TemplateMention.REMINDER_FEES,
    TemplateMention.COLLECTOR_PAYMENT_OPTIONS,
    TemplateMention.COLLECTOR_ACCOUNT_NUMBER,
    TemplateMention.COLLECTOR_REGISTER_NUMBER,
    TemplateMention.COLLECTOR_PHONE,
    TemplateMention.COLLECTOR_COURT_PHONE,
    TemplateMention.COLLECTOR_EMAIL,
    TemplateMention.COLLECTOR_NICKNAME,
    TemplateMention.COLLECTOR_NAME,
    TemplateMention.COLLECTOR_ADDRESS_ADDRESS,
    TemplateMention.COLLECTOR_ADDRESS_ZIP,
    TemplateMention.COLLECTOR_ADDRESS_CITY,
    TemplateMention.COLLECTOR_CVR,
    TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS,
    TemplateMention.CREDITOR_ZIPCODE,
    TemplateMention.CREDITOR_CITY,
    TemplateMention.CREDITOR_COMPANY_IDENTIFIER,
    TemplateMention.CREDITOR_IF_IS_COMPANY,
    TemplateMention.USER_NAME,
    TemplateMention.USER_FIRST_NAME,
    TemplateMention.IF_USER,
    TemplateMention.PAYMENT_ID,
    TemplateMention.JOURNAL_NUMBER,
    TemplateMention.GENERIC_EMAIL_SUBJECT,
    TemplateMention.CIVIL_COURT_NAME,
    TemplateMention.CIVIL_COURT_ADDRESS,
    TemplateMention.CIVIL_COURT_CITY,
    TemplateMention.CIVIL_COURT_ZIP,
    TemplateMention.CIVIL_COURT_EMAIL,
    TemplateMention.CIVIL_COURT_PHONE,
    TemplateMention.CIVIL_COURT_EAN,
    TemplateMention.CIVIL_REG_NO,
    TemplateMention.CIVIL_ACCOUNT_NO,
    TemplateMention.FOUNDATION_DATE,
    TemplateMention.FOUNDATION_TYPE,
    TemplateMention.LATEST_TRIBUNAL_REFERENCE,
    TemplateMention.CONDITIONAL_ELSE,
    TemplateMention.CONDITIONAL_END_IF,
];
const TemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.PAYMENT_PLAN_HTML,
    TemplateMention.CONTACT_ADDRESS_INLINE,
    TemplateMention.CONTACT_ADDRESS_FORMATTED,
    TemplateMention.DEBTOR_ADDRESS_INLINE,
    TemplateMention.DEBTOR_ADDRESS_FORMATTED,
    TemplateMention.DEBT_TABLE,
    TemplateMention.DEBT_SPECIFICATION,
    TemplateMention.DEBT_OVERVIEW,
    TemplateMention.SIGN_FIELDS,
];
const LetterTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.OVERPAYMENT_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.DOCUMENTATION,
];
const EBoksTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.DOCUMENTATION,
];
const SMSTemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.DEBTOR_WEB_LINK,
];
const EmailTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.SATISFACTION_BUTTONS,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.DEBTOR_WEB_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.DOCUMENTATION,
];
export const getMentionSuggestions = (lang, templateType, propertyTypes, tenant) => {
    let suggestions = [];
    switch (templateType) {
        case TemplateType.LETTER:
            suggestions = LetterTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
            }));
            break;
        case TemplateType.EBOKS:
            suggestions = EBoksTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
            }));
            break;
        case TemplateType.SMS:
            suggestions = SMSTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
            }));
            break;
        case TemplateType.EMAIL:
            suggestions = EmailTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
            }));
            break;
        case TemplateType.AUTOCALL:
            suggestions = SMSTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
            }));
            break;
    }
    if (propertyTypes) {
        suggestions = [
            ...suggestions,
            ...propertyTypes.map((propertyType) => {
                let field = '';
                switch (propertyType.type) {
                    case PropertyDataType.file:
                        field = `{{{properties.${propertyType.handle}}}}`;
                        break;
                    case PropertyDataType.checkbox:
                        field = `{{#if properties.${propertyType.handle}}}`;
                        break;
                    default:
                        field = `{{properties.${propertyType.handle}}}`;
                }
                return {
                    label: propertyType.type === PropertyDataType.checkbox
                        ? `${propertyType.label} ⚙️`
                        : `${propertyType.label} ➕`,
                    description: propertyType.description || '-',
                    example: '',
                    field: field,
                };
            }),
        ];
        if ([TemplateType.EBOKS, TemplateType.EMAIL, TemplateType.LETTER].includes(templateType)) {
            const tables = getCaseVoucherTables(tenant?.settings.customCaseVoucherTables || [], lang);
            suggestions = suggestions.concat(tables.map((table) => ({
                label: `${table.name} ☰`,
                description: table.description,
                example: '',
                field: `{{{caseVoucherTables.${table.handle}}}}`,
            })));
        }
    }
    return suggestions;
};
//# sourceMappingURL=suggestions.js.map